import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-virtual-card-qr-code-view',
    templateUrl: './virtual-card-qr-code-view.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VirtualCardQrCodeViewComponent {
    @Input() qrData!: string;
    @Input() cardNumber!: string;

    constructor(
        public activeModal: NgbActiveModal,
        public readonly translateService: TranslateService) {
    }
}
